<template>
  <div>
    <div class="relative outline outline-1 outline-offset-[-1px] rounded-md overflow-hidden" :class="inputAreaFocused ? 'outline-blue-400 outline-2' : 'outline-slate-200'">
        <slot name="input" />
        <textarea v-if="!$slots.input" v-model="message" rows="3" :placeholder="placeholder" :disabled="disabled ? 'disabled' : undefined" class="w-full border-0 min-h-0 text-base font-normal" style="resize: none; outline-style: none;" @focus="inputAreaFocused = !disabled" @blur="inputAreaFocused = false" />
        <div class="flex flex-row items-center p-1">
          <template v-if="enableFiles">
            <div class="flex-none">
              <label class="flex items-center p-2 text-slate-400 hover:text-slate-500 cursor-pointer">
                <input class="hidden" name="file_selector" type="file" accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*" @change="event => files.push(event.target.files[0])" />
                <span class="material-icons-o rotate-45">attach_file</span>
                <span v-if="!files.length" class="pl-2">{{ $t('feedbackForm.attachFile') }}</span>
              </label>
            </div>
            <div v-if="files.length" class="flex-none">{{ files.length }}</div>
          </template>
          <div class="grow"></div>
          <div>
            <BtnWrapper
              class="p-2 bg-blue-500 rounded-md hover:bg-blue-400 w-24 h-10 transition-colors text-sm text-white disabled:bg-slate-300"
              :label="$t('feedbackForm.send')"
              :loading="sending"
              :disabled="disabled"
              @click.stop="postMessage(message)"
            />
          </div>
        </div>
      </div>

      <div class="pt-1 flex flex-row flex-wrap w-full gap-1">
        <div v-for="(file, key) in files" :key="key" class="flex-none items-center bg-slate-200 rounded-xl px-2">
          <div class="flex flex-row items-center text-gray-400 cursor-default">
            <div class="text-sm flex-1 truncate">{{ file.name }}</div>
            <div class="material-icons-o cursor-pointer hover:text-gray-600 !text-sm flex-none px-1" @click.stop="removeFile(key)">close</div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import BtnWrapper from "@/components/UI/BtnWrapper.vue"

export default defineComponent({
  name: 'ChatInputArea',

  components: { BtnWrapper },

  props: {
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    enableFiles: {
      type: Boolean,
      default: true
    },
    sending: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      inputAreaFocused: false,
      message: '',
      files: [],
    }
  },

  watch: {
    files: {
      handler () {
        this.$emit('update:files', this.files)
      },
      deep: true
    },

    message () {
      this.$emit('update:modelValue', this.message)
    }
  },

  methods: {
    removeFile(key) {
      this.files.splice(key, 1)
    },

    postMessage (text) {
      this.$emit('send', text)
      this.message = ''
    }
  }
})
</script>

<style scoped>
textarea {
  padding-block: .375rem;
  padding-inline: .75rem;
}
</style>